"use client";

import { createContext, useContext, useState, useCallback } from "react";

interface HelpContextValue {
  isOpen: boolean;
  openHelp: () => void;
  closeHelp: () => void;
}

const HelpContext = createContext<HelpContextValue | undefined>(undefined);

interface HelpProviderProps {
  children: React.ReactNode;
}

export function HelpProvider({ children }: HelpProviderProps) {
  const [isOpen, setIsOpen] = useState(false);

  const openHelp = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeHelp = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <HelpContext.Provider value={{ isOpen, openHelp, closeHelp }}>
      {children}
    </HelpContext.Provider>
  );
}

/**
 * Hook to access help panel state.
 * Must be used within a HelpProvider.
 */
export function useHelp(): HelpContextValue {
  const context = useContext(HelpContext);
  if (context === undefined) {
    throw new Error("useHelp must be used within a HelpProvider");
  }
  return context;
}
